import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  CountriesFilter,
  CountryDetails,
} from '../../features/countries/countriesSlice';

export function fetchCountries(countriesFilter: CountriesFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: countriesFilter,
  };

  return axios
    .get('/location/countries/getcountries', config)
    .then(res => res.data);
}

export function fetchCountryDetails(countryId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { countryId },
  };

  return axios
    .get('/location/countries/getcountrydetails', config)
    .then(res => res.data);
}

export function addCountry(countryData: CountryDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/location/countries/addcountry', countryData, config)
    .then(res => res.data);
}

export function updateCountry(countryData: CountryDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put('/location/countries/updatecountry', countryData, config)
    .then(res => res.data);
}

export function deleteCountry(countryId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { countryId },
  };

  return axios
    .delete('/location/countries/deletecountry', config)
    .then(res => res.data);
}
